export default "__VITE_ASSET__84787cd9__$_?nuxt_component=async&nuxt_component_name=SvgoNext__"